import { Fill, Stroke, Style, Text } from 'ol/style';

const minSize = 10; // Minimum font size
const maxSize = 12; // Maximum font size
export function gridLineStyle(name: string, isAccident: boolean, multiple: number, res: number) {
  const fontSize = Math.max(minSize, Math.min(maxSize, 20 / res)); // Scale text within limit
  const isFarOut = res > 2.2;

  return new Style({
    stroke: new Stroke({ color: isAccident ? '#ffd27f' : '#437c8d', width: 3 }),

    text: isFarOut
      ? undefined
      : new Text({
          text: `${name ?? ''}${multiple > 1 ? `\n x${multiple}` : ''}`,
          font: `${fontSize}px Arial, sans-serif`,
          fill: new Fill({ color: '#a8c6ce' }),
          backgroundFill: new Fill({ color: '#0e4959' }),
          padding: [4, 4, 3, 4],
        }),
  });
}
